/**
 * Chain link, with a slash through it when not linked.
 *
 * Shared so the per-widget toggle and the global ticker box show the same
 * symbol — the whole point of the icon is that a reader learns it once.
 *
 * ⚠️ The earlier version was drawn wrong, which is why it read as a blob: it
 * stacked two half-chains, an `opacity={0}` path and a stray `<line>`, and its
 * second arc (`M10.172 13.828 … l4 4`) ran off the bottom of the 24×24 canvas
 * and was clipped. One shape plus a slash is correct and instantly readable.
 */
export function LinkIcon({ linked, className = 'w-3.5 h-3.5' }: {
  linked: boolean;
  className?: string;
}) {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757" />
      <path d="M10.81 15.312a4.5 4.5 0 01-1.242-7.244l4.5-4.5a4.5 4.5 0 016.364 6.364l-1.757 1.757" />
      {!linked && <path d="M3 3l18 18" />}
    </svg>
  );
}
